import { render, staticRenderFns } from "./forexTraderHistory.vue?vue&type=template&id=1ec6d076"
import script from "./forexTraderHistory.vue?vue&type=script&lang=js"
export * from "./forexTraderHistory.vue?vue&type=script&lang=js"
import style0 from "./forexTraderHistory.vue?vue&type=style&index=0&id=1ec6d076&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports